var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row m-0" },
    [
      _c(
        "div",
        { staticClass: "col-md-12 col-lg-12 col-sm-12 pl-0 xs-pr-0" },
        [
          _c("div", { staticClass: "first_table" }, [
            _c("table", { staticClass: "table activity-tracker-table" }, [
              _vm.showHeaders
                ? _c("thead", [
                    _c(
                      "tr",
                      [
                        _c("th", { staticClass: "filter-th wd-35 sticky" }),
                        _c(
                          "th",
                          { staticClass: "wd-35 text-center sticky-checkbox" },
                          [
                            _vm.dataList.length
                              ? _c("div", { staticClass: "checkbox" }, [
                                  _c("label", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.isCheckAll,
                                          expression: "isCheckAll",
                                        },
                                      ],
                                      attrs: {
                                        id: "all-checkbox",
                                        type: "checkbox",
                                        value: "selectAll",
                                      },
                                      domProps: {
                                        checked: Array.isArray(_vm.isCheckAll)
                                          ? _vm._i(
                                              _vm.isCheckAll,
                                              "selectAll"
                                            ) > -1
                                          : _vm.isCheckAll,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.checkAll()
                                        },
                                        change: function ($event) {
                                          var $$a = _vm.isCheckAll,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = "selectAll",
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.isCheckAll = $$a.concat([
                                                  $$v,
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.isCheckAll = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.isCheckAll = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _c("span", { staticClass: "cr" }),
                                  ]),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _vm._l(_vm.headers, function (cellVal, indexes) {
                          return [
                            _vm.selectedColumns.indexOf(cellVal) > -1
                              ? _c(
                                  "th",
                                  {
                                    key: indexes,
                                    class: {
                                      "wd-30":
                                        cellVal === "user_name_and_email",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm._f("capitalize")(cellVal)) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        }),
                        _c("th", { staticClass: "dropdown-column" }, [
                          _c(
                            "div",
                            {
                              staticClass: "dropdown angle text-left",
                              attrs: { id: "userPreferences" },
                            },
                            [
                              _vm._m(0),
                              _c("right-filter", {
                                staticClass: "dropdown-menu",
                                attrs: {
                                  headers: _vm.headers,
                                  selectedColumns: _vm.diffSelectedColumns,
                                  type: "admin",
                                },
                                on: {
                                  setSelectedColumns:
                                    _vm.SetUserSelectedColumns,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _c(
                "tbody",
                _vm._l(_vm.dataList, function (rowVal, index) {
                  return _c(
                    "tr",
                    { key: index },
                    [
                      _c("td", { staticClass: "menu-td wd-35 sticky" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "dropdown dropdown-export export-activity-menu",
                            attrs: { id: "trackerActionDots" + index },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: { "margin-top": "1px" },
                                attrs: { "data-toggle": "dropdown" },
                                on: { click: _vm.menuDropdown },
                              },
                              [_vm._m(1, true)]
                            ),
                            _c(
                              "ul",
                              {
                                staticClass:
                                  "activitytrackermenu dropdown-menu export-menu",
                                class: _vm.changeClass ? "addReverse" : "",
                              },
                              [
                                _c(
                                  "li",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetPasswordUser(
                                          rowVal,
                                          rowVal.deactivated
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: { disabled: rowVal.deactivated },
                                      },
                                      [
                                        _c("img", {
                                          staticClass:
                                            "tracker-images lock_image",
                                          attrs: {
                                            src: "/static/images/icons/lock_icon.svg",
                                            alt: "lock-icon",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "text-color-blue" },
                                          [_vm._v("Reset Password")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c("li", { staticClass: "divider" }),
                                _c(
                                  "li",
                                  {
                                    on: {
                                      click: function ($event) {
                                        !rowVal.deactivated
                                          ? _vm.deActivateUser([rowVal])
                                          : null
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "text-color-delete-red menu-dots-links",
                                        attrs: { disabled: rowVal.deactivated },
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "tracker-images",
                                          attrs: {
                                            src: "/static/images/icons/delete_icon.svg",
                                            alt: "delete-icon",
                                          },
                                        }),
                                        _c("span", [_vm._v("Deactivate")]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _c("td", { staticClass: "text-center sticky-checkbox" }, [
                        !rowVal.deactivated
                          ? _c("div", { staticClass: "checkbox" }, [
                              _c("label", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.selectedRow,
                                      expression: "selectedRow",
                                    },
                                  ],
                                  attrs: {
                                    id: "single-checkbox",
                                    type: "checkbox",
                                  },
                                  domProps: {
                                    value: rowVal.user_id,
                                    checked: Array.isArray(_vm.selectedRow)
                                      ? _vm._i(
                                          _vm.selectedRow,
                                          rowVal.user_id
                                        ) > -1
                                      : _vm.selectedRow,
                                  },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$a = _vm.selectedRow,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = rowVal.user_id,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.selectedRow = $$a.concat([
                                                $$v,
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.selectedRow = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.selectedRow = $$c
                                        }
                                      },
                                      function ($event) {
                                        return _vm.updateCheckall(rowVal)
                                      },
                                    ],
                                  },
                                }),
                                _c("span", { staticClass: "cr" }),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._l(_vm.headers, function (cellVal, indexes) {
                        return [
                          _vm.selectedColumns.indexOf(cellVal) > -1
                            ? _c(
                                "td",
                                { key: indexes },
                                [
                                  cellVal === "user_name_and_email"
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "member_img" },
                                          [
                                            rowVal[cellVal].profile_pic
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "relative-pos",
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "profile-pic",
                                                      attrs: {
                                                        src: rowVal[cellVal]
                                                          .profile_pic,
                                                        alt: "profile-pic",
                                                      },
                                                    }),
                                                    rowVal[cellVal]
                                                      .is_restricted
                                                      ? _c("img", {
                                                          staticClass:
                                                            "notification-red-on-image",
                                                          attrs: {
                                                            src: "/static/images/icons/blocked_icon.png",
                                                            alt: "blocked-icon",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "profile-pic profile-pic-title custom-profile-pic-title relative-pos",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getInitials(
                                                          rowVal[cellVal]
                                                            .first_name,
                                                          rowVal[cellVal]
                                                            .last_name
                                                        )
                                                      ) + " "
                                                    ),
                                                    rowVal[cellVal]
                                                      .is_restricted
                                                      ? _c("img", {
                                                          staticClass:
                                                            "notification-red-on-image",
                                                          attrs: {
                                                            src: "/static/images/icons/blocked_icon.png",
                                                            alt: "blocked-icon",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "member-text" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "member-name" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      rowVal[cellVal]
                                                        .first_name +
                                                        " " +
                                                        rowVal[cellVal]
                                                          .last_name
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "member-email" },
                                              [
                                                _vm._v(
                                                  _vm._s(rowVal[cellVal].email)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          _vm._s(
                                            rowVal[cellVal] === null
                                              ? "-"
                                              : rowVal[cellVal]
                                          )
                                        ),
                                      ],
                                ],
                                2
                              )
                            : _vm._e(),
                        ]
                      }),
                      _c("td", { staticClass: "dropdown-column" }),
                    ],
                    2
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm.dataList.length === 0
            ? _c("div", { staticClass: "norecords_wrapper p-20" }, [
                _c("div", { staticClass: "no-records-found" }, [
                  _vm._v("No Records Found"),
                ]),
              ])
            : _vm._e(),
          _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
        ],
        1
      ),
      _c("deactivate-users-modal", {
        attrs: { users: _vm.selectedUser, account: _vm.account },
        on: {
          deactivated: function ($event) {
            return _vm.getUsers()
          },
        },
      }),
      _c("reset-password-user-modal", {
        attrs: { user: _vm.selectedResetPasswordUser },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "plus-circle", attrs: { "data-toggle": "dropdown" } },
      [
        _c("img", {
          attrs: {
            src: "/static/images/icons/plus_circle_icon.svg",
            alt: "plus-circle-icon",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "dropdown-toggle" }, [
      _c("i", { staticClass: "fa fa-ellipsis-v menu-dots" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }